export const toursTranslations = {
  welcome_tour: {
    steps: {
      company: {
        title: 'Bienvenue sur votre Espace Web Entreprise.',
        content: {
          '1': 'Utilisez le menu',
          '2': '“Entreprises”',
          '3': "et son sous-menu pour consulter les informations générales, les coordonnées et les habilitations des correspondants administratifs, les paramètres de votre contrat et de vos produits d'épargne, ainsi que vos coordonnées bancaires.",
        },
        footer: 'Si vous identifiez une erreur, contactez le support.',
      },

      main_menu: 'Utilisez ce menu pour naviguer dans le panneau distributeur.',

      employees_create: {
        title: 'Créez vos adhérents 1/2',
        content:
          'Saisissez manuellement les informations de vos adhérents de façon unitaire en cliquant sur “+ Créer”.',
      },

      employees_bulk_upload: {
        title: 'Créez vos adhérents 2/2',
        content:
          "Ou réalisez une affiliation en masse à l'aide d'un fichier d'importation en cliquant sur “Affiliation en masse”.",
      },

      campaigns: {
        title: 'Créez et suivez vos opérations collectives',
        content: 'Depuis le menu “Opérations”.',
      },

      final: {
        title: 'La visite guidée est terminée',
        content: 'Vous pouvez la reprendre à tout moment depuis votre profil.',
      },
    },
  },
};
